import { ActionCreatorWithoutPayload, ActionCreatorWithPayload, createAction } from "@reduxjs/toolkit";
import { ChatWithShortInfo } from "@sms/shared/chat/chat.interface";

const handleConnectSocketChat: ActionCreatorWithoutPayload = createAction<void>("chat/handleConnectSocket");
const handleReconnectSocketChat: ActionCreatorWithoutPayload = createAction<void>("chat/handleReconnectSocket");

const handleCreateChat: ActionCreatorWithPayload<ChatWithShortInfo> = createAction("chat/handleCreate");

const handleUpdateChat: ActionCreatorWithPayload<ChatWithShortInfo> = createAction("chat/handleUpdate");

const handleCountAllNotification: ActionCreatorWithPayload<number> = createAction("chat/handleCountAllNotification");

const fetchCountAllNotificationsSuccess: ActionCreatorWithPayload<number> = createAction(
  "chat/fetchCountAllNotificationsSuccess"
);

const fetchCountAllNotificationsError: ActionCreatorWithPayload<number> = createAction(
  "chat/fetchCountAllNotificationsError"
);

export default {
  handleConnectSocketChat,
  handleReconnectSocketChat,
  handleCreateChat,
  handleUpdateChat,
  handleCountAllNotification,
  fetchCountAllNotificationsSuccess,
  fetchCountAllNotificationsError
};
